import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class Acte extends ShadowDOMElement {
	static className = "Acte";
	
	constructor() {
		super();
		this.container1Id = "authentique";
		this.container2Id = "prive";
		this.selectFieldId = "txtNature";
	}

	render() {
		return html`
		<title-field label="Acte"></title-field>
		
		<row-with-tooltip tooltip-text="Un acte sous seing privé est un acte rédigé par les associés. Un acte authentique est rédigé par un notaire">
			<select-field id="${this.selectFieldId}" label="Nature de l'acte *" value="" required name="id_act_nature">
				<option-component label="Choisir" value="0"></option-component>
				<option-component label="Acte authentique" value="1"></option-component>
				<option-component label="Acte sous seing privé" value="2"></option-component>
			</select-field>
		</row-with-tooltip>
		
		<div-container id="${this.container1Id}" visible="false">
			<row-wrapper>
				<text-field label="Identité de l'officier ministériel" name="ministerial_office_identity"></text-field>
			</row-wrapper>
			<row-with-tooltip tooltip-text="Date de l'acte" >
				<date-field label="Date de l'acte" name="act_date"></date-field>
			</row-with-tooltip>
			<row-with-tooltip tooltip-text="Lieu de signature" >
				<text-field label="Lieu" name="act_location"></text-field>
			</row-with-tooltip>
		</div-container>
		
		<div-container id="${this.container2Id}" visible="false">
			<row-with-tooltip tooltip-text="Date de l'acte" >
				<date-field label="Date de signature *" required name="act_date"></date-field>
			</row-with-tooltip>
			<row-with-tooltip tooltip-text="Lieu de signature">
				<text-field label="Lieu" name="act_location"></text-field>
			</row-with-tooltip>
		</div-container>
	    `;
	}

	firstUpdated() {
		const selectField = this.shadowRoot.querySelector (`#${this.selectFieldId}`);
		const container1 = this.shadowRoot.querySelector (`#${this.container1Id}`);
		const container2 = this.shadowRoot.querySelector (`#${this.container2Id}`);

		selectField.addEventListener("change", (event) => {
			const selectedValue = event.target.value;

			if (selectedValue === "1") {
				container1.visible = true;
				container2.visible = false;
			} else if (selectedValue === "2") {
				container1.visible = false;
				container2.visible = true;
			} else {
				container1.visible = false;
				container2.visible = false;
			}
		});
	}
	
	isTransient (){
		return false;
	}
}

customElements.define ("acte-component", Acte);
